export const SITE_TYPE = "GODOMALL";

export const GODOMALL_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/member/login.php" },
  SIGNUP_INTRO: {
    target: `${SITE_TYPE}:SIGNUP_INTRO`,
    url: "/member/join_method.php",
  },
  SIGNUP_AGREEMENT: {
    target: `${SITE_TYPE}:SIGNUP_AGREEMENT`,
    url: "/member/join_agreement.php",
  },
  SIGNUP_MAIN: {
    target: `${SITE_TYPE}:SIGNUP_MAIN`,
    url: "/member/join.php",
  },
  SIGNUP_COMPLETE: {
    target: `${SITE_TYPE}:SIGNUP_COMPLETE`,
    url: "/member/join_ok.php",
  },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/mypage/index.php" },
  FIND_ID: {
    target: `${SITE_TYPE}:FIND_ID`,
    url: "/member/find_id.php",
  },
  FIND_PASSWORD: {
    target: `${SITE_TYPE}:FIND_PASSWORD`,
    url: "/member/find_password.php",
  },
  CART: {
    target: `${SITE_TYPE}:CART`,
    url: "/order/cart.php",
  },
  POLICY: { target: `${SITE_TYPE}:POLICY`, url: "/service/agreement.php" },
  PRIVACY: { target: `${SITE_TYPE}:PRIVACY`, url: "/service/private.php" },
  CHECK_ORDER: {
    target: `${SITE_TYPE}:CHECK_ORDER`,
    url: "/mypage/order_list.php",
  },
  CANCEL_ORDER: {
    target: `${SITE_TYPE}:CANCEL_ORDER`,
    url: "/mypage/cancel_list.php",
  },
  REFUND_LIST: {
    target: `${SITE_TYPE}:REFUND_LIST`,
    url: "/mypage/refund_list.php",
  },
  COUPON: {
    target: `${SITE_TYPE}:COUPON`,
    url: "/mypage/coupon.php",
  },
  MILEAGE: {
    target: `${SITE_TYPE}:MILEAGE`,
    url: "/mypage/mileage.php",
  },
  WISH_LIST: {
    target: `${SITE_TYPE}:WISH_LIST`,
    url: "/mypage/wish_list.php",
  },
  DELIVERY_ADDR_LIST: {
    target: `${SITE_TYPE}:DELIVERY_ADDR_LIST`,
    url: "/mypage/shipping.php",
  },
  MY_PAGE_PASSWORD: {
    target: `${SITE_TYPE}:MY_PAGE_PASSWORD`,
    url: "/mypage/my_page_password.php",
  }, // 개인정보 변경 진입 전 비밀번호 입력 페이지
  MEMBER_MODIFY: {
    target: `${SITE_TYPE}:MEMBER_MODIFY`,
    url: "/mypage/my_page.php",
  },
  MY_PAGE_QA: {
    target: `${SITE_TYPE}:MY_PAGE_QA`,
    url: "/mypage/mypage_qa.php",
  },
  // 회원가입 페이지 특정되지 않음
};
